import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./shared/header/header.component";
import { SidebarmenuComponent } from "./shared/sidebarmenu/sidebarmenu.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { environment } from '../environments/environment';
import { ChatbotComponent } from "./shared/chatbot/chatbot.component";
import { ScrollButtonComponent } from "./shared/scroll-button/scroll-button.component";
import { APP_ROUTES } from './constants/routes.constants';

const CHATBOT_HIDDEN_ROUTES = [
  APP_ROUTES.ADMIN,
  APP_ROUTES.DASHBOARD,
  APP_ROUTES.CREATE_WONDER,
  APP_ROUTES.LOGIN,
];

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, SidebarmenuComponent, FooterComponent, ChatbotComponent, ScrollButtonComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'TG24-038-DESTINO-TURISTICO-INTELIGENTE';
  private router = inject(Router);
  showChatbot = environment.showChatbot;

  get isChatbotVisible(): boolean {
    if (!this.showChatbot) return false;
    const url = this.router.url.split('?')[0];
    return !CHATBOT_HIDDEN_ROUTES.some(route => url.includes(route));
  }
}
